import { cn } from "@omni/utils/styles";
import { components, GroupBase, MenuProps } from "react-select";

import { useIsModal } from "@/components/General/Modal/context/modal.context";

export const MenuComponent = <TOption, IsMulti extends boolean>(
    props: MenuProps<TOption, IsMulti, GroupBase<TOption>>
) => {
    const isModal = useIsModal();

    return (
        <components.Menu
            {...props}
            className={cn(props.className, "tw:overflow-hidden!", {
                "tw:relative! tw:top-0!": isModal
            })}
        />
    );
};
